"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSidebarNavItems = exports.Sidebar = exports.SidebarContextConsumer = exports.useSidebarContext = exports.SidebarContextProvider = void 0;
var tslib_1 = require("tslib");
var NavItem_1 = require("@reactionable/core/lib/nav/NavItem");
var react_1 = tslib_1.__importStar(require("react"));
var Button_1 = tslib_1.__importDefault(require("react-bootstrap/Button"));
var Col_1 = tslib_1.__importDefault(require("react-bootstrap/Col"));
var Collapse_1 = tslib_1.__importDefault(require("react-bootstrap/Collapse"));
var Container_1 = tslib_1.__importDefault(require("react-bootstrap/Container"));
var Row_1 = tslib_1.__importDefault(require("react-bootstrap/Row"));
var react_i18next_1 = require("react-i18next");
var NavItem_2 = require("../../nav/NavItem");
var contextProvider = NavItem_1.createNavItemContextProvider({});
exports.SidebarContextProvider = contextProvider.NavItemContextProvider, exports.useSidebarContext = contextProvider.useNavItemContext, exports.SidebarContextConsumer = contextProvider.NavItemContextConsumer;
var SidebarItems = function (_a) {
    var children = _a.children;
    var t = react_i18next_1.useTranslation().t;
    var _b = tslib_1.__read(react_1.useState(true), 2), open = _b[0], setOpen = _b[1];
    var navItems = exports.useSidebarContext().navItems;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Collapse_1.default, { in: open },
            react_1.default.createElement(Col_1.default, { xs: "auto", className: "sidebar-left-side", style: {
                    borderRight: 'solid 1px',
                    height: '93vh',
                    paddingTop: '1vh',
                    paddingLeft: 0,
                    paddingRight: 0,
                } },
                !open && (react_1.default.createElement(Button_1.default, { onClick: function () { return setOpen(!open); }, "aria-controls": t('Collapse sidebar'), "aria-expanded": open }, t('Collapse sidebar'))), navItems === null || navItems === void 0 ? void 0 :
                navItems.map(NavItem_2.navItemToComponent))),
        react_1.default.createElement(Col_1.default, { className: "sidebar-right-side", style: { height: '89vh', overflow: 'auto' } }, children)));
};
function Sidebar(_a) {
    var children = _a.children;
    return (react_1.default.createElement(Container_1.default, { fluid: true, className: "sidebar-container", style: {
            paddingLeft: 0,
            paddingRight: 0,
        } },
        react_1.default.createElement(Row_1.default, null,
            react_1.default.createElement(exports.SidebarContextProvider, null,
                react_1.default.createElement(SidebarItems, { children: children })))));
}
exports.Sidebar = Sidebar;
function setSidebarNavItems(navItems) {
    var setNavItems = exports.useSidebarContext().setNavItems;
    react_1.useEffect(function () {
        setNavItems(navItems);
    }, navItems);
}
exports.setSidebarNavItems = setSidebarNavItems;
//# sourceMappingURL=Sidebar.js.map